<template>
    <div class="modal fade" id="selectedCartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">محصول به سبد خرید شما اضافه شد</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9">
                                <div class="main-a-s">
                                    <img :src="productInfo.PicPath" />
                                    <span class="name-d">  {{productInfo.Name}} </span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="price-mo">
                                    <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                        <div class="price-value">
                                            <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price ) | formatNumber }}</span>
                                            <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                {{((productInfo.Price  ) - (((productInfo.Price ) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                            </span>
                                            <span class="price-currency"> تومان </span>
                                        </div>
                                        <div v-if="productInfo.DiscountPercent != 0" class="price-discount" >
                                            <span>
                                                {{productInfo.DiscountPercent}}
                                            </span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr />
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 col-sm-6 col-xs-12">
                                <span class="sho-h">
                                    شما {{  cart.CartInfo.CartDetailsCount }}  کالا در سبد خرید دارید
                                </span>
                            </div>
                            <div class="col-12 col-md-6 col-sm-6 col-xs-12">
                                <div class="b-price-t">
                                    <span>
                                        جمع سبد خرید
                                    </span>
                                    <span>
                                        {{ cart.CartInfo.AmountPayable | formatNumber}} تومان
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div class="row" v-if="cart.CartInfo.IsApplyFreeDelivery">
                            <div class="col-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="center fd-pish"><span>توجه : سود شما ارسال رایگان با پست پیشتاز</span></div>
                            </div>
                            
                        </div>
                        <div class="row btn-box-c">

                            <div class="col-6 col-md-6 col-sm-6 col-xs-6" >
                                <div v-if="baseInfo.IsActiveOrder">
                                    <router-link v-if="isUserLogined" to="/chooseAddress" class="btn btn-reject" data-dismiss="modal">تکمیل خرید</router-link>
                                    <a v-else href="/login" class="btn btn-reject">ورود و ثبت سفارش</a>
                                </div>
                            </div>
                            <div class="col-6 col-md-6 col-sm-6 col-xs-6">
                                <div class="text-left">
                                    <a href="/cart"    class="btn btn-save">مشاهده سبد خرید</a>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        props: {
            productInfo: {
                type: Object,
            },
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
             
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        }
    }
</script>

<style scoped>
    .fd-pish {
        margin: 10px;
        color: #c1c139;
    
    }
        .fd-pish span {
            display: inline-block;
            border-radius: 8px;
            padding: 10px;
            border: 1px dashed #c1c139;
        }
      .b-price-t {
        text-align:left;
    }
        .b-price-t span {
            font-size: 14px;
            font-weight: 600;
     
        }
     .sho-h {
        font-size: 13px;
        font-weight: 500;
        color: #b08c8c;
    }

    .price-mo .price-main {
        padding: 20px 20px 0 0;
    }
    .price-mo .price-value {
        font-size: 20px;
        line-height: 35px;
        float: right;
    }
    .price-mo .discount::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0px;
        border-top: 1px solid #c6c6c6;
        -webkit-transform: rotate(-30deg);
        transform: rotate(0deg);
        top: -1px;
    }
    .price-mo .discount {
        display: inline-block;
        position: relative;
        font-size: 14px;
    }
    .price-mo .discountvalue {
        position: absolute;
        top: -19px;
        right: 1px;
        font-size: 14px;
        color: #c6c6c6;
    }
    .price-mo .discount::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0px;
        border-top: 1px solid #c6c6c6;
        -webkit-transform: rotate(-30deg);
        transform: rotate(0deg);
        top: -1px;
    }

    .price-mo .discountvalue-t {
        position: absolute;
        left: -50px;
    }
    .price-mo .discountvalue {
        font-size: 14px;
        color: #c6c6c6;
    }
    .price-mo .price-currency {
        font-size: 14px;
        line-height: 1.294;
    }









    .modal-content .modal-header {
        background-color: #fff !important;
        border: 1px solid #ddd !important;
    }

    .main-a-s .name-d {
        font-size: 13px;
        color: #06d
    }
    .price-discount {
        margin-right: 20px;
    }
    @media (min-width: 576px) {
        
        .modal-dialog {
            max-width: 600px;
            margin: 1.75rem auto;
        }
    }

    .btn-box-c {
        background-color: #e8d7d7;
        padding-top: 15px;
        padding-bottom: 8px;
        margin-top: 15px;
    }

    .modal-content .modal-body {
        padding-top: 25px;
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
    }

    .main-a-s {
        display: flex;
        justify-content: right;
        align-items: center;
        flex-direction: row;
    }

    .price-mo {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .main-a-s .name-d {
    }

    .main-a-s img {
        margin-left: 15px;
        width: 90px;
    }

    .div-loader {
        position: absolute;
        width: 102%;
        height: 100%;
        top: 0;
        left: -1px;
        background-color: #ddd;
        padding-top: 6px;
        text-align: center
    }

        .div-loader img {
            width: 40px;
        }

    .btn-estelam-main {
        position: relative;
    }

    .modal-content {
        border-radius: unset;
    }

    .modal-content {
        border-radius: 8px;
    }

    .wiki-sign {
        cursor: pointer;
        position: unset;
        margin-right: 0px;
        width: unset;
        height: unset;
        display: unset;
        margin-top: unset;
        vertical-align: middle;
    }

        .wiki-sign::after {
            content: "\ea04";
            font-family: 'Nucleo Outline';
            color: #ababab;
            font-size: 18px;
            line-height: 1.048;
            position: unset;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
        }

    .title-message {
        text-align: right;
        margin-bottom: 10px;
    }

    .title {
        margin-left: 10px;
    }

    .carrierName {
        font-weight: bold;
        font-size: 15px;
        color: #666
    }

    .okStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #95db95;
        color: #fff;
        font-weight: bold;
        width: 100%;
        display: block;
    }

    .notOkStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #cc5e5e;
        color: #fff;
        font-weight: bold;
        display: block;
    }

    .radio label::before {
        right: 15px;
    }

    .radio input[type="radio"]:checked + label::after {
        right: 18px
    }

    .radio label::before, .radio label::after {
        right: 15px;
    }

    .content-img-radio img {
        width: 100px;
        height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 8px;
        padding: 5px;
    }

    .modal-content .modal-header {
        background-color: #aec7f4;
    }

    .modal-content .modal-header {
        background-color: #aec7f4;
    }

    .modal-content .modal-header {
        border-bottom: none;
        padding-top: 8px;
        padding-right: 24px;
        padding-bottom: 13px;
        padding-left: 24px;
    }

    .modal h5 {
        font-size: 14px;
        font-weight: 500;
        color: #b08c8c;
    }

    .modal .modal-header .close {
        color: #b08c8c !important;
    }

    .btn-estelam {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
    }

    .modal-content .modal-header button {
        left: 13px;
        right: unset;
        top: 6px;
    }

    .close {
        font-size: 31px !important;
    }

    .modal .modal-header .close {
        color: #fff;
    }

    .btn-div {
        text-align: center;
    }

    .div-logo-item {
        border-bottom: 1px solid #ddd;
        padding: 25px 5px 25px 10px;
    }

    .btn-div {
        margin-top: 15px;
    }

    .price-all {
        padding: 10px 0 10px 0;
        text-align: center;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-main {
        text-align: center;
    }
</style>